import React from 'react';

import styles from './SwitchInput.module.css';

export const SwitchInputSlider = () => {
  return <div className={styles.SwitchInput__Slider} />;
};
